export default "__VITE_ASSET__C2uVFHOs__"